import {Pack, PacksSortableKeys, PackTypes, SortDirection} from "lib/types";
import {orderBy} from "lodash";

export const filterPacksByType = (packs: Pack[], type: PackTypes): Pack[] => {
  if (!packs) {
    return [];
  }

   switch (type) {
    case PackTypes.TEAM:
      return packs.filter((pack: Pack) => pack.team_share);
    case PackTypes.PRIVATE:
      return packs.filter((pack: Pack) => !pack.team_share && !pack.is_shared);
    default:
      return packs;
  }
}

export const getPackType = (pack: Pack) => pack.team_share ? PackTypes.TEAM : PackTypes.PRIVATE;

export const getPacksInSuperpack = (packs: Pack[], parent?: string): Pack[] => (
  packs?.filter((pack) => parent ? pack?.superpack_id === parent : !pack?.superpack_id)
);

export const sortPacks = (packs: Pack[], sortKey: string, direction: SortDirection): Pack[] => {
  const ordered = orderBy(packs, [(pack) => pack[sortKey].toLocaleLowerCase()], [direction]);

  if (sortKey !== PacksSortableKeys.updated) {
    return ordered.reverse();
  }

  return ordered;
};


const sharedIdentifier = 'x';

export const isSharedPack = (id: string) => id && id.startsWith(sharedIdentifier);
